import React, { memo } from 'react';
import { connect } from 'react-redux';
import dayjs from 'dayjs';

import { selectedSeatsHumanSelector, ticketsSelector, concessionsSelector } from '../selectors/index';
import hideFromRoutes from '../hoc/hideFromRoutes';


const Movie = (props) => {
  const getDayOfWeek = (time) => {
    var now = new Date(time);
    var days = ['Domingo','Lunes','Martes','Miércoles','Jueves','Viernes','Sábado'];
    var dayOfWeek = days[now.getDay()]
    return dayOfWeek;
  }
  return (
    <ul className="nostyle poster-list">
        <li className="poster-item">
          <figure className="poster-item__img">
            { /[.jpg|.jpeg|.png]$/.test(props.movieUrlPoster) && <img src={ props.movieUrlPoster } alt="" /> }
          </figure>

        <div className="poster-item__info">
          <p className="poster-item__text"><div className="black bold poster-title">Película: </div>{ props.movieName }{props.movieLanguage}</p>
          <p className="poster-item__text"><div className="black bold poster-title">Cine: </div>{ props.cinemaName }</p>
          <p className="poster-item__text"><div className="black bold poster-title">Fecha: </div>{getDayOfWeek(props.dateTime)} { props.date }</p>
          <p className="poster-item__text"><div className="black bold poster-title">Función: </div>{ dayjs(props.dateTime).format('H:mm').toUpperCase() }</p>
          {props.tickets !== ''
            ? <p className="poster-item__text">
                <div className="black bold poster-title">Entradas: </div>
                {props.tickets}
              </p>
            : null 
          }
{
  props.concessions !== '' && props.concessions !== " (0 €)" && props.sessionId !== null
    ? <p className="poster-item__text">
    <div className="black bold poster-title"></div>
    {props.concessions}
    </p>
  : null
}
          {props.selectedSeats !== ''
            ? <p className="poster-item__text">
						  <div className="black bold poster-title">Butacas: </div>
                { props.selectedSeats }
              </p>
            : null
          }
</div>
      </li>
    </ul>
  );
}


const areEqual = (prevProps, nextProps) => {
  if (prevProps.movieName === nextProps.movieName &&
    prevProps.cinemaName === nextProps.cinemaName &&
    prevProps.tickets === nextProps.tickets &&
    prevProps.selectedSeats === nextProps.selectedSeats) {
  return true;
}

return false;
};

const mapStateToProps = state => {
  const { showtime } = state;

  return {
    movieUrlPoster: showtime.movie.url_poster,
    movieName: showtime.movie.name,
    movieLanguage: showtime.movie.language ? ' ' + showtime.movie.language : '',
    cinemaName: showtime.cinema.name,
    date: showtime.showtimes.date,
    dateTime: showtime.showtimes.datetime,
    tickets: ticketsSelector(state),
    selectedSeats: selectedSeatsHumanSelector(state),
    concessions: concessionsSelector(state),
    sessionId: state.payments.sessionId
};
};

export default hideFromRoutes(
  memo(
    connect(mapStateToProps)(Movie), 
    areEqual
  ), 
  ['/error']
);
